import { Box, LinearProgress } from '@mui/material';

export const LoadingBanner = () => {
  return (
    <Box>
      <LinearProgress />
    </Box>
  );
}